/** Step bookkeeping for <ka-walkthrough>, kept pure so it can be tested without a DOM. */

export interface FlowState {
  index: number;
  total: number;
  finished: null | 'done' | 'skipped';
}

export const startFlow = (total: number): FlowState => ({ index: 0, total, finished: null });

/** Finishes step `index` if it is the current one; finishing the last step ends the flow. */
export function completeStep(s: FlowState, index: number): FlowState {
  if (s.finished || index !== s.index) return s;
  return index + 1 >= s.total ? { ...s, finished: 'done' } : { ...s, index: index + 1 };
}

export const backStep = (s: FlowState): FlowState =>
  s.finished ? s : { ...s, index: Math.max(0, s.index - 1) };

export const skipFlow = (s: FlowState): FlowState => ({ ...s, finished: 'skipped' });

const key = (activity: string) => `ka.walkthrough.${activity}`;

/** Whether this device has finished or skipped the activity's walkthrough. */
export function walkthroughSeen(
  activity: string,
  store: Pick<Storage, 'getItem'> | undefined = globalThis.localStorage,
): boolean {
  try {
    return store?.getItem(key(activity)) === '1';
  } catch {
    return false; // private mode: show it again, it is skippable
  }
}

export function markWalkthroughSeen(
  activity: string,
  store: Pick<Storage, 'setItem'> | undefined = globalThis.localStorage,
): void {
  try {
    store?.setItem(key(activity), '1');
  } catch {
    /* a nicety; ignore storage failures */
  }
}
